import type { UIStringsOverride } from "../i18n-ui.ts";

/** Croatian (hr) UI strings. */
export const hr: UIStringsOverride = {
  actions: {
    addToCursor: "Dodaj u Cursor",
    addToVscode: "Dodaj u VS Code",
    askAI: "Pitaj AI o ovoj stranici",
    connectMcp: "Poveži se s MCP-om",
    copied: "Kopirano!",
    copyClaudeCode: "Kopiraj naredbu Claude Code",
    copyCode: "Kopiraj kôd",
    copyCodex: "Kopiraj naredbu Codex",
    copyMarkdown: "Kopiraj kao Markdown",
    copyServerUrl: "Kopiraj URL poslužitelja",
    edit: "Uredi na GitHubu",
    export: "Izvezi",
    exportEpub: "Izvezi u EPUB",
    exportPdf: "Izvezi u PDF",
    generating: "Generiranje…",
    openIn: "Otvori u {name}",
    openInChat: "Otvori u chatu",
    scrollToTop: "Natrag na vrh",
  },
  ask: {
    ai: "AI",
    clear: "Očisti razgovor",
    close: "Zatvori",
    copy: "Kopiraj razgovor",
    empty: "Postavite pitanje o dokumentaciji.",
    error: "Žao nam je, nešto je pošlo po zlu.",
    label: "Postavi pitanje",
    placeholder: "Postavite pitanje…",
    send: "Pošalji",
    tip: "Savjet: Chat možete otvoriti i zatvoriti pomoću",
    title: "Pitaj AI",
    you: "Vi",
  },
  banner: { dismiss: "Zatvori obavijest" },
  changelog: {
    description: "Ažuriranja proizvoda i napomene o izdanjima.",
    showReleases: "Prikaži izdanja {version}",
    title: "Popis promjena",
  },
  content: { diagramError: "Ovaj dijagram nije moguće prikazati." },
  feedback: {
    no: "Ne",
    question: "Je li vam ova stranica bila korisna?",
    thanks: "Hvala na povratnoj informaciji!",
    yes: "Da",
  },
  languageSwitcher: { label: "Jezik", untranslated: "Nije prevedeno" },
  nav: {
    back: "Natrag",
    breadcrumb: "Navigacijski put",
    closeNavigation: "Zatvori navigaciju",
    deprecated: "zastarjelo",
    featured: "Istaknuto",
    githubRepository: "GitHub repozitorij",
    navigation: "Navigacija",
    primary: "Glavna",
    sections: "Odjeljci",
    toggleNavigation: "Otvori ili zatvori navigaciju",
    toggleTheme: "Promijeni temu boja",
  },
  notFound: {
    description: "Nismo mogli pronaći stranicu koju tražite.",
    home: "Natrag na početnu",
    title: "Stranica nije pronađena",
  },
  page: {
    lastUpdated: "Posljednje ažuriranje",
    next: "Sljedeće",
    pagination: "Straničenje",
    previous: "Prethodno",
    skipToContent: "Prijeđi na sadržaj",
  },
  search: {
    all: "Sve",
    allLanguages: "Svi jezici",
    askAi: "Pitaj AI",
    askAiHint: "Dobijte trenutačni odgovor od AI-ja",
    button: "Pretraži",
    devOnly: "Pretraživanje je dostupno u produkcijskoj verziji.",
    error: "Nešto je pošlo po zlu. Pokušajte ponovno.",
    label: "Pretraži dokumentaciju",
    navigate: "navigacija",
    noResults: "Nema rezultata.",
    open: "otvori",
    placeholder: "Pretraži dokumentaciju…",
    popular: "Popularno",
    preview: "pregled",
    results: "Rezultati",
  },
  toc: { title: "Na ovoj stranici" },
};
